import React from "react";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Input from "@material-ui/core/Input";
import NumberFormat from "react-number-format";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles(theme => ({
  select: {
    fontSize: "0.75rem"
  },
  option: {
    fontSize: "0.75rem"
  },
  formControl: {
    minWidth: 120,
    maxWidth: 300,
    margin: "0px",
    marginTop: "16px"
  },
  typography: {
    color: "rgba(0, 0, 0, 0.54)",
    padding: 0,
    fontSize: "1rem",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1,
    transform: "translate(0, 1.5px) scale(0.75)",
    transformOrigin: "top left",
    letterSpacing: "0.00938em",
    transition:
      "color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
  }
}));

const SalesData = ({
  onChange,
  disabled,
  error,
  sale_data_title,
  sales_data,
  onContactsSearch,
  buyer_contacts,
  reseller_contacts,
  ...props
}) => {
  const handleChange = event => {
    onChange(event, "sales_data");
  };

  const handleContactsAsyncChange = (event, values, type) => {
    if (!values) {
      values = { id: "", contact_id: "" };
    }
    event.target.value = values.id;
    if (type === "reseller_id") {
      event.target.value = values.contact_id;
    }
    event.target.name = type;
    onChange(event, "sales_data");
  };

  const handleContactsAsyncSearch = (event, values) => {
    onContactsSearch(values);
  };

  const classes = useStyles();
  const is_resale_options = [
    { id: 1, name: "Reventa" },
    { id: 2, name: "Venta final" }
  ];
  return (
    <React.Fragment>
      <Typography variant="h6" className="mt-2">
        {sale_data_title}
      </Typography>
      <div className="row">
        <div className="col-md-2">
          <FormControl
            className="mt-3 mr-2"
            style={{ minWidth: 150, fontSize: "0.75rem" }}
            name="is_resale"
          >
            Es reventa o venta final?
            <Select
              native
              name="is_resale"
              inputProps={{
                name: "is_resale",
                className: "is_resale"
              }}
              style={{ minWidth: 150, fontSize: "0.75rem" }}
              disabled={disabled}
              onChange={handleChange}
              value={sales_data.is_resale}
              input={<Input id="grouped-native-select" name="no_usage" />}
            >
              <option value="" />
              {is_resale_options.map(no_usage => (
                <option id={no_usage.id} value={no_usage.id}>
                  {no_usage.name}
                </option>
              ))}
            </Select>
          </FormControl>
        </div>
      </div>
      {(sales_data.is_resale === 1 || sales_data.is_resale === "1") && (
        <div className="row">
          <div className="col-md-12">
            <Typography variant="subtitle1" className="mt-2">
              Datos de reventa
            </Typography>
          </div>
          <div className="col-md-2">
            <FormControl
              className="mt-3 mr-2"
              style={{ minWidth: 150, fontSize: "0.75rem" }}
              name="reseller_id"
            >
              Revendedor
              <Autocomplete
                id={"reseller_id"}
                style={{ width: "100%" }}
                getOptionLabel={option =>
                  option.business_name || option.hansa_name || ""
                }
                getOptionSelected={(option, value) =>
                  String(option.contact_id) === String(value.contact_id)
                }
                options={reseller_contacts.options || []}
                loading={reseller_contacts.loading}
                value={
                  sales_data.reseller_id
                    ? (reseller_contacts.options || []).find(
                        v =>
                          String(v.contact_id) ===
                          String(sales_data.reseller_id)
                      ) || null
                    : null
                }
                onChange={(event, values) => {
                  handleContactsAsyncChange(event, values, "reseller_id");
                }}
                openOnFocus
                autoComplete
                autoHighlight
                noOptionsText={
                  <Typography variant="caption">Sin resultados</Typography>
                }
                name={"reseller_id"}
                includeInputInList
                className="mr-2"
                classes={{
                  option: classes.option
                }}
                renderOption={option => (
                  <Typography variant="caption">
                    {option.business_name || option.hansa_name || ""}
                  </Typography>
                )}
                renderInput={params => (
                  <TextField
                    {...params}
                    placeholder="Buscar revendedor"
                    name={"reseller_id"}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <React.Fragment>
                          {reseller_contacts.loading ? (
                            <CircularProgress color="inherit" size={20} />
                          ) : null}
                          {params.InputProps.endAdornment}
                        </React.Fragment>
                      )
                    }}
                    InputLabelProps={{
                      ...params.InputLabelProps,
                      shrink: true
                    }}
                    inputProps={{
                      ...params.inputProps,
                      style: { fontSize: "0.75rem", width: 70 }
                    }}
                  />
                )}
              />
            </FormControl>
          </div>
          <div className="col-md-2">
            <TextField
              id="reseller_delivery_date"
              name="reseller_delivery_date"
              label="Fecha de entrega"
              disabled={disabled}
              type="date"
              placeholder="Ingrese la fecha de entrega"
              onChange={handleChange}
              value={sales_data.reseller_delivery_date || ""}
              margin="normal"
              className="mr-2 "
              InputLabelProps={{
                shrink: true
              }}
              inputProps={{ style: { minWidth: 150, fontSize: "0.75rem" } }}
            />
          </div>

          <div className="col-md-2">
            <TextField
              id="reseller_payment_date"
              name="reseller_payment_date"
              label="Fecha de pago"
              disabled={disabled}
              type="date"
              placeholder="Ingrese la fecha de pago"
              onChange={handleChange}
              value={sales_data.reseller_payment_date || ""}
              margin="normal"
              className="mr-2 "
              InputLabelProps={{
                shrink: true
              }}
              inputProps={{ style: { minWidth: 150, fontSize: "0.75rem" } }}
            />
          </div>
          <div className="col-md-2">
            <TextField
              id="reseller_delivery_km"
              name="reseller_delivery_km"
              label="Km entrega"
              disabled={disabled}
              type="number"
              placeholder="Ingrese los km de entrega"
              onChange={handleChange}
              value={sales_data.reseller_delivery_km || ""}
              margin="normal"
              className="mr-2 "
              InputLabelProps={{
                shrink: true
              }}
              inputProps={{ style: { minWidth: 150, fontSize: "0.75rem" } }}
            />
          </div>
          <div className="col-md-2">
            <NumberFormat
              id="resale_price"
              name="resale_price"
              label="Precio de reventa"
              disabled={disabled}
              placeholder="Ingrese el precio de reventa"
              onChange={handleChange}
              value={sales_data.resale_price || ""}
              margin="normal"
              className="mr-2 "
              InputLabelProps={{
                shrink: true
              }}
              customInput={TextField}
              inputProps={{ style: { minWidth: 150, fontSize: "0.75rem" } }}
              thousandSeparator={true}
              prefix={"$"}
            />
          </div>
          <div className="col-md-2">
            <FormControl
              className="mt-3 mr-2"
              style={{ minWidth: 150, fontSize: "0.75rem" }}
              name="is_consignment"
            >
              Consignación
              <Select
                native
                name="is_consignment"
                inputProps={{
                  name: "is_consignment",
                  className: "is_consignment"
                }}
                style={{ minWidth: 150, fontSize: "0.75rem" }}
                disabled={disabled}
                onChange={handleChange}
                value={sales_data.is_consignment ? 1 : 0}
                input={<Input id="grouped-native-select" name="no_usage" />}
              >
                <option value={0}>No</option>
                <option value={1}>Sí</option>
              </Select>
            </FormControl>
          </div>
        </div>
      )}
      {(sales_data.is_resale == 2 || sales_data.is_resale == "2") && (
        <>
          <div className="row">
            <div className="col-md-12">
              <Typography variant="subtitle1" className="mt-2">
                Datos de venta final
              </Typography>
            </div>
            <div className="col-md-2">
              <FormControl
                className="mt-3 mr-2"
                style={{ minWidth: 150, fontSize: "0.75rem" }}
                name="buyer_id"
              >
                Comprador final
                <Autocomplete
                  id={"buyer_id"}
                  style={{ width: "100%" }}
                  getOptionLabel={option => option.hansa_name}
                  getOptionSelected={(option, value) =>
                    option.hansa_name === value
                  }
                  options={buyer_contacts.options}
                  loading={buyer_contacts.loading}
                  value={
                    sales_data.buyer_id
                      ? buyer_contacts.options.find(
                          v => v.id === sales_data.buyer_id
                        ) || {}
                      : {}
                  }
                  onInputChange={handleContactsAsyncSearch}
                  onChange={(event, values) => {
                    handleContactsAsyncChange(event, values, "buyer_id");
                  }}
                  autoComplete
                  noOptionsText={
                    <Typography variant="caption">Sin resultados</Typography>
                  }
                  name={"buyer_id"}
                  includeInputInList
                  className="mr-2"
                  classes={{
                    option: classes.option
                  }}
                  renderInput={params => (
                    <TextField
                      {...params}
                      placeholder="Ingrese un contacto"
                      name={"buyer_id"}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {buyer_contacts.loading ? (
                              <CircularProgress color="inherit" size={20} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        )
                      }}
                      InputLabelProps={{
                        ...params.InputLabelProps,
                        shrink: true
                      }}
                      inputProps={{
                        ...params.inputProps,
                        style: { fontSize: "0.75rem", width: 70 }
                      }}
                    />
                  )}
                />
              </FormControl>
            </div>
            <div className="col-md-2">
              <TextField
                id="buyer_sale_date"
                name="buyer_sale_date"
                label="Fecha de venta"
                disabled={disabled}
                type="date"
                placeholder="Ingrese la fecha de venta"
                onChange={handleChange}
                value={sales_data.buyer_sale_date || ""}
                margin="normal"
                className="mr-2 "
                InputLabelProps={{
                  shrink: true
                }}
                inputProps={{ style: { minWidth: 150, fontSize: "0.75rem" } }}
              />
            </div>
            <div className="col-md-2">
              <TextField
                id="buyer_payment_date"
                name="buyer_payment_date"
                label="Fecha de pago"
                disabled={disabled}
                type="date"
                placeholder="Ingrese la fecha de pago"
                onChange={handleChange}
                value={sales_data.buyer_payment_date || ""}
                margin="normal"
                className="mr-2 "
                InputLabelProps={{
                  shrink: true
                }}
                inputProps={{ style: { minWidth: 150, fontSize: "0.75rem" } }}
              />
            </div>
            <div className="col-md-2">
              <TextField
                id="buyer_sale_km"
                name="buyer_sale_km"
                label="Km venta"
                disabled={disabled}
                type="number"
                placeholder="Ingrese los km de venta"
                onChange={handleChange}
                value={sales_data.buyer_sale_km || ""}
                margin="normal"
                className="mr-2 "
                InputLabelProps={{
                  shrink: true
                }}
                inputProps={{ style: { minWidth: 150, fontSize: "0.75rem" } }}
              />
            </div>
            <div className="col-md-2">
              <NumberFormat
                id="buyer_price"
                name="buyer_price"
                label="Precio de venta"
                disabled={disabled}
                placeholder="Ingrese el precio de venta"
                onChange={handleChange}
                value={sales_data.buyer_price || ""}
                margin="normal"
                className="mr-2 "
                InputLabelProps={{
                  shrink: true
                }}
                customInput={TextField}
                inputProps={{ style: { minWidth: 150, fontSize: "0.75rem" } }}
                thousandSeparator={true}
                prefix={"$"}
              />
            </div>
          </div>
        </>
      )}

      <div className="row">
        <div className="col-md-2">
          <FormControl
            className="mt-3 mr-2"
            style={{ minWidth: 150, fontSize: "0.75rem" }}
            name="has_completed_documentation"
          >
            Entrega de documentación
            <Select
              native
              name="has_completed_documentation"
              inputProps={{
                name: "has_completed_documentation",
                className: "has_completed_documentation"
              }}
              style={{ minWidth: 150, fontSize: "0.75rem" }}
              disabled={disabled}
              onChange={handleChange}
              value={
                sales_data.has_completed_documentation == "1" ||
                sales_data.has_completed_documentation == 1
                  ? 1
                  : 0
              }
              input={<Input id="grouped-native-select" name="no_usage" />}
            >
              <option>Seleccione</option>
              <option value={0}>Parcial</option>
              <option value={1}>Completa</option>
            </Select>
          </FormControl>
        </div>
        {(sales_data.has_completed_documentation == 0 ||
          sales_data.has_completed_documentation == "0") && (
          <div className="col-md-12">
            <TextField
              id="missing_documentation"
              name="missing_documentation"
              label="Documentación faltante"
              fullWidth
              disabled={disabled}
              placeholder="Ingrese que falta"
              onChange={handleChange}
              value={sales_data.missing_documentation || ""}
              margin="normal"
              className="mr-2 "
              InputLabelProps={{
                shrink: true
              }}
              inputProps={{ style: { minWidth: 150, fontSize: "0.75rem" } }}
            />
          </div>
        )}
        <div className="col-md-12">
          <TextField
            id="comments"
            name="comments"
            fullWidth
            label="Observaciones"
            disabled={disabled}
            placeholder="Ingrese observaciones"
            onChange={handleChange}
            value={sales_data.comments || ""}
            margin="normal"
            className="mr-2 "
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{ style: { minWidth: 150, fontSize: "0.75rem" } }}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default SalesData;
